export default "__VITE_ASSET__DEz3eNdy__"